import { setPreference } from '@fs/zion-preferences'

export default function updateObjectPreference<T>(
  defaultValue: T | undefined,
  preferenceValue: T | '' | undefined,
  preferenceKey: string
): void {
  // If defaultValue and preferenceValue are of type Record<string, unknown>, then look through the first layer and update the preference if there are any missing fields.
  if (
    defaultValue &&
    defaultValue instanceof Object &&
    !(defaultValue instanceof Array) &&
    preferenceValue &&
    preferenceValue instanceof Object &&
    !(preferenceValue instanceof Array)
  ) {
    let updateValue = false

    // Type assertion to treat both as records for safer property access
    const defaultRecord = defaultValue as Record<string, unknown>
    const preferenceRecord = preferenceValue as Record<string, unknown>

    const updatedDefaultValue = Object.keys(defaultRecord).reduce((accum, defaultKey) => {
      const accumRecord = accum as Record<string, unknown>
      if (preferenceRecord[defaultKey] !== undefined) {
        accumRecord[defaultKey] = preferenceRecord[defaultKey]
      } else {
        // At least one field is missing and we need to update the whole preference to include this new value via updatedDefaultValue
        updateValue = true
      }
      return accum
    }, defaultValue)

    updateValue && setPreference(preferenceKey, updatedDefaultValue)
  }
}
